import React, { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { service, factories, models } from "powerbi-client";

const powerbiService = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory,
);

const PowerBIReport = () => {
  const { instance, accounts } = useMsal();
  const reportRef = useRef<HTMLDivElement>(null);

  const WORKSPACE_ID = "77223481-37c2-4058-840d-17d03177deca";
  const REPORT_ID = "ebd1048a-4959-427a-9fcb-8238191ecf8e";

  const loadReport = async () => {
    try {
      // Token
      let tokenResponse;
      try {
        tokenResponse = await instance.acquireTokenSilent({
          account: accounts[0],
          scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
        });
      } catch {
        tokenResponse = await instance.acquireTokenPopup({
          scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
        });
      }

      const token = tokenResponse.accessToken;

      // Get Report Details
      const res = await fetch(
        `https://api.powerbi.com/v1.0/myorg/groups/${WORKSPACE_ID}/reports/${REPORT_ID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await res.json();

      console.log("Report Data:", data);

      if (!reportRef.current) return;

      powerbiService.reset(reportRef.current);

      const embedConfig = {
        type: "report",
        id: data.id,
        embedUrl: data.embedUrl,
        accessToken: token,
        tokenType: models.TokenType.Aad,
      };

      powerbiService.embed(reportRef.current, embedConfig);
    } catch (err) {
      console.error("POWER BI ERROR:", err);
    }
  };

  useEffect(() => {
    if (accounts.length > 0) {
      loadReport();
    }
  }, [accounts]);

  return (
    <div style={{ height: "100vh" }}>
      <div ref={reportRef} style={{ height: "100%" }} />
    </div>
  );
};

export default PowerBIReport;
